import { useTranslation } from 'react-i18next';

// Some legacy routes mount without an i18next provider. Their installed
// react-i18next version returns the key and ignores defaultValue in that case.
export default function useTranslatedText() {
  const translation = useTranslation();
  return {
    ...translation,
    t: (key, options = {}) => {
      const text = translation.t(key, options);
      if (text !== key) return text;
      return String(options.defaultValue || key).replace(/\{\{(\w+)\}\}/g, (match, name) => options[name] ?? match);
    }
  };
}
